<template>
  <div>
    <modal-provider
      :fullscreen-breakpoint="768"
      name="cart-modal"
      :width="900"
      @before-open="beforeModalOpen"
      @before-close="beforeModalClose"
      :classList="computedClassList"
      :title="$t('cart_title')"
    >
      <template v-slot:modal-heading>
        <h3 class="modal__title">
          {{ $t('cart_title') }}
        </h3>
      </template>
      <div v-if="cartSort.products.length">
        <div class="cart__wrapper">
          <store-select @isLoading="changeLoadingStatus" v-show="hasOnlyPickup && storesInCity && storesInCity.length"></store-select>
          <ul class="cart__products-list" v-if="availableProductsInStore.length">
            <template>
              <li v-for="product in availableProductsInStore" :key="product.id" class="cart__products-list-item">
                <cart-item :product="product" :show-product-delivery-status="isCheckout" show-inner-items></cart-item>
              </li>
            </template>
          </ul>
          <div class="unavailable-list" v-if="unAvailableProductsInStore.length">
            <div class="unavailable-list__title">
              <span v-if="unavailableItemsForPurchase.length">{{ $t('delivery-store-balance.cart-unavailable-for-city') }}</span>
              <span v-else>{{ $t('delivery-store-balance.cart-unavailable-for-store') }}</span>
              <button v-if="unAvailableProductsInStore.length" class="unavailable-list__remove-all" @click="removeAllUnavailable()">{{ $t('delivery-store-balance.cart-remove-all')}}</button>
            </div>
            <ul class="cart__products-list cart__products-list--unavailable">
              <template>
                <li v-for="product in unAvailableProductsInStore" :key="product.id" class="cart__products-list-item">
                  <cart-item :product="product" :show-product-delivery-status="isCheckout" show-inner-items></cart-item>
                </li>
              </template>
            </ul>
          </div>
          <div
            class="modal__info modal__info--total"
            :class="{
              'modal__info--together-cheaper': discountSeveralGoodsParams,
              'modal__info--page--checkout': isCheckout
            }"
          >
            <div class="cart__buy-more" v-if="cartSort.cart">
              <p class="cart__buy-more-text" v-if="cartSort.cart.originCost < 750">
                {{ $t('cart_buy_more') }}
              </p>
              <button
                class="link link--pseudo cart__back-to "
                :class="{ 'cart__back-to--adaptive--show': isCheckout }"
                :title="$t('cart_return_to_shopping')"
                @click="hideModal"
              >
                <svg width="16"
                     height="16"
                     viewBox="0 0 16 16"
                     fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M3.8 7L9.4 1.4L8 0L0 8L8 16L9.4 14.6L3.8 9H16V7H3.8Z"
                    fill="#3E77AA"
                  />
                </svg>
                <span v-if="isCheckout">{{ $t('cart_return_to_checkout') }}</span>
                <span v-else>{{ $t('cart_return_to_shopping') }}</span>
              </button>
              <BonusesInModal :isCheckout="isCheckout" />
              <div
                class="cart__info-message-wrap"
                v-if="
                  (cartTotalPriceMoreThenTwoThousands &&
                    $t('cart_info_message_title_on') &&
                    $t('cart_info_message_text_on')) ||
                    (!cartTotalPriceMoreThenTwoThousands &&
                    $t('cart_info_message_title_off') &&
                    $t('cart_info_message_text_off'))
                "
              >
                <InfoMessage
                  :title="
                    cartTotalPriceMoreThenTwoThousands
                      ? $t('cart_info_message_title_on')
                      : $t('cart_info_message_title_off')
                  "
                  :text="
                    cartTotalPriceMoreThenTwoThousands
                      ? $t('cart_info_message_text_on')
                      : $t('cart_info_message_text_off')
                  "
                  :with-tooltip="
                    !!(cartTotalPriceMoreThenTwoThousands
                      ? $t('cart_info_message_text_on')
                      : $t('cart_info_message_text_off'))
                  "
                  type="warn"
                />
              </div>
              <!--              <div class="cart__info-message-wrap" v-if="cart.notifications && cart.notifications.length">-->
              <!--                <InfoMessage-->
              <!--                  v-for="(item, i) in cart.notifications"-->
              <!--                  :key="i"-->
              <!--                  :title="item.title"-->
              <!--                  :text="item.text"-->
              <!--                  :with-tooltip="!!item.text"-->
              <!--                  type="info"-->
              <!--                />-->
              <!--              </div>-->
            </div>
            <div class="cart__total">
              <div v-if="togetherCheaperDiscount" class="cart__total-text cart__total-text--together-cheaper">
                <span>{{ $t('cart_together_discount') }}</span>
                <span class="cart__total-number cart__total-number--together-cheaper"
                >-{{ togetherCheaperDiscount | currencyFormatter }}</span
                >
              </div>
              <div v-if="hasFullDiscount" class="cart__total-text cart__total-text--discount">
                <span>{{ $t('cart_discount') }}</span>
                <span class="cart__total-number cart__total-number--discount"
                >{{ fullDiscountValue | currencyFormatter }}</span
                >
              </div>
              <div v-if="cartSort.cart" class="cart__total-text">
                <span class="cart__total-title">{{ $t('cart_total') }}:</span>
                <div class="cart__total-number-wrap">
                  <span class="cart__total-number--old" v-if="fullOriginalCost && fullOriginalCost > cartSort.cart.originCost">{{ fullOriginalCost | currencyFormatter }}</span>
                  <span class="cart__total-number">{{ cartSort.cart.originCost | currencyFormatter }}</span>
                </div>
              </div>
              <a
                @click="pushAnalyticEventNavToCheckout"
                v-if="!isCheckout"
                :href="computedCheckoutData.link"
                class="cart__btn cart__btn--buy"
                :class="{ 'cart__btn--disabled': unAvailableProductsInStore.length || (hasOnlyPickup && !userStore) }"
              >{{ computedCheckoutData.label }}
              </a>
            </div>
          </div>
          <!--          <ProductsBuyTogether-->
          <!--            v-if="cartProductsIds"-->
          <!--            :product-id-list="cartProductsIds"-->
          <!--            :title="$t('cart_buy_together_title')"-->
          <!--            :slider-breakpoints="buyTogetherSliderBreakpoints"-->
          <!--            :slider-space-between="15"-->
          <!--            simple-product-card-->
          <!--            without-container-->
          <!--            is-toggle-slider-show-->
          <!--            is-in-cart-->
          <!--          />-->
          <rendered-blocks uid="cart" :without-container="true" class="cart-modal-upsell-products" />
          <template v-if="!discountSeveralGoodsParams && !isCheckout && !isManager && config.isEnabledOneClickAndCallback">
            <div class="modal__hr">
              {{ $t('popup_or') }}
            </div>
            <div class="modal__info one-click">
              <div class="one-click__text one-click-text">
                <span class="one-click-text__title">{{ $t('cart_one_click_title') }}</span>
                <p class="one-click-text__paragraph" v-html="$t('cart_one_click_text')"></p>
              </div>
              <QuickOrderForm
                class="one-click__form"
                is-buy-one-click
                :userData="userData"
                :productId="cartProductsIds[0]"
                is-from-cart
                @onSubmit="onQuickOrderFormSubmit"
                @onError="onQuickOrderFormError"
              >
                <template #form-footer="{ submitHandler, isButtonDisabled }">
                  <button
                    class="one-click-form__btn cart__btn cart__btn--invert"
                    @click.prevent="submitQuickOrderForm(submitHandler)"
                    :disabled="isOneClickLoading || isButtonDisabled"
                  >
                    {{ $t('cart_one_click_btn') }}
                  </button>
                </template>
              </QuickOrderForm>
            </div>
          </template>
        </div>
      </div>
      <div v-else-if="oneClickSuccess">
        <p class="modal__one-click-success" v-html="oneClickSuccess.message"></p>
      </div>
      <div v-else class="empty-cart">
        <div class="empty-cart__img"></div>
        <h3 class="modal__title modal__title--center empty-cart__title">
          {{ $t('cart_empty_title') }}
        </h3>
        <p class="empty-cart__text">{{ $t('cart_empty_text') }}</p>
      </div>
      <loader :is-loading="isLoading"></loader>
    </modal-provider>
    <notifications group="error" position="top center" :max="3"></notifications>
    <notifications group="success" position="top center" :max="3"></notifications>
    <notifications group="warn" position="top center" :max="3"></notifications>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import StoreSelect from '@/components/cart/StoreSelect.vue'
import Loader from '@/components/helpers/Loader'
import CartItem from '@/components/cart/cart-item/CartItem'
// import ProductCard from './ProductCard'
import currencyFormatter from '../../filters/CurrencyFormatter'
import BonusesInModal from './BonusesInModal'
import InfoMessage from '../../components/helpers/InfoMessage'
// import ProductsBuyTogether from '../../components/product/product-block/ProductsBuyTogether'
import { EsputnikService, GoogleTagManagerService, RtbHouseService } from '@/services/AnalyticService'
import QuickOrderForm from '@/components/product/quick-order/QuickOrderForm.vue'
import RenderedBlocks from '@/components/rendered-blocks/RenderedBlocks.vue'

export default {
  name: 'CartModal',
  components: {
    // ProductsBuyTogether,
    InfoMessage,
    BonusesInModal,
    // ProductCard,
    QuickOrderForm,
    CartItem,
    RenderedBlocks,
    StoreSelect,
    Loader
  },
  props: {
    isCheckout: Boolean
  },
  data: function () {
    return {
      isLoading: false,
      isOneClickLoading: false,
      discountSeveralGoodsParams: window.discountSeveralGoods,
      oneClickSuccess: false,
      buyTogetherSliderBreakpoints: {
        319: {
          slidesPerView: 1.5
        },
        375: {
          slidesPerView: 2.2
        },
        600: {
          slidesPerView: 3.2
        },
        769: {
          slidesPerView: 4
        }
      }
    }
  },
  methods: {
    ...mapActions(['FETCH_CART_BONUSES_INFO', 'SET_LOADING_COMPONENT', 'REMOVE_PRODUCTS_FROM_CART']),
    removeAllUnavailable () {
      const ids = this.unAvailableProductsInStore && this.unAvailableProductsInStore.map(el => {
        return el.id
      })
      this.changeLoadingStatus(true)
      this.REMOVE_PRODUCTS_FROM_CART({ ids }).then(() => {
        this.changeLoadingStatus(false)
      })
    },
    beforeModalOpen () {
      document.querySelector('body').classList.add('simple-overflow-hidden')
      RtbHouseService.ShoppingCartStatusCode(this.cartProductsIds.map(el => el.toString()))
    },
    changeLoadingStatus (val) {
      this.isLoading = val
    },
    beforeModalClose () {
      document.querySelector('body').classList.remove('simple-overflow-hidden')
      this.oneClickSuccess = false
      this.$store.dispatch('CHANGE_CART_RTB_HOUSE_CODE_FLAG', false)
    },
    hideModal () {
      this.$modal.hide(this.cartModalName)
    },
    onQuickOrderFormSubmit (data) {
      if (data.message) {
        this.oneClickSuccess = data
      } else if (!data.success) {
        this.$modal.hide(this.cartModalName)
        this.$modal.show('not-available-products', {
          ...data?.order['order_composition'],
          allProducts: this.cartSort.products
        })
      }
      if (data.success) {
        this.pushAnalyticsCode(data.orderNumber)

        // Отправка данных по заказу в eSputnik
        EsputnikService.sendPurchasedItemsInfo({
          products: data.analytics_data,
          orderNumber: data.orderNumber,
          tags: data.esputnikBlockId ? { 'blockId': [data.esputnikBlockId] } : null,
          isCheckout: false
        })
      }

      this.$store.dispatch('GET_FULL_CART').then(() => {
        this.isOneClickLoading = false
      })
    },
    onQuickOrderFormError (error) {
      this.$notify({
        group: 'error',
        title: this.$t('error'),
        text: error,
        type: 'error'
      })
      this.isOneClickLoading = false
    },
    submitQuickOrderForm (handler) {
      this.isOneClickLoading = true
      handler()
    },
    pushAnalyticsCode (orderNumber) {
      if (this.cartSort.products.length) {
        let transactionProducts = []
        for (let product of this.cartSort.products) {
          transactionProducts.push({
            name: `${product.name}`,
            sku: `${product.code}`,
            category: ``,
            price: `${product.price}`,
            quantity: `${product.itemQuantity}`
          })
        }

        GoogleTagManagerService.pushToDatalayer({
          transactionId: `${orderNumber}`, // Order number
          transactionAffiliation: `OneClick`,
          transactionTotal: `${this.cartSort.cart.originCost}`, // Total order sum
          transactionTax: ``,
          transactionShipping: ``,
          transactionProducts: transactionProducts
        })
      }
      GoogleTagManagerService.pushToDatalayer({
        event: `Purchase`,
        eventCategory: `ThankYou Page`,
        eventAction: `One-click-Purchase`,
        eventLabel: orderNumber
      })

      GoogleTagManagerService.checkoutEvent({
        analyticsData: this.cartInfoForEcommerce,
        actionField: { 'step': 6, 'option': 'One Click Cart Popup' },
        params: {
          'event': 'gtm-ee-event-checkout-step-6',
          'gtm-ee-event-action': 'Checkout Step 6 One Click Cart Popup'
        }
      })

      GoogleTagManagerService.purchaseEvent({
        analyticsData: this.cartInfoForEcommerce,
        actionField: {
          'id': orderNumber,
          'affiliation': 'One Click Cart Popup',
          'revenue': `${this.cart.originCost}`
        },
        params: {
          'event': 'gtm-ee-event-purchase',
          'gtm-ee-event-action': 'Purchase'
        }
      })

      const pushToFacebook = () => {
        try {
          window.fbq('track', 'Purchase', {
            content_ids: this.analyticsProductsCodes,
            content_type: 'product',
            value: `${this.cartSort.cart.originCost}`,
            currency: window.config?.currency?.currency_code
          })
        } catch (err) {
          setTimeout(function () {
            pushToFacebook()
          }, 1000)
        }
      }
      pushToFacebook()
    },
    pushAnalyticEventNavToCheckout () {
      GoogleTagManagerService.pushToDatalayer({
        'event': 'nav-to-cart-gtm-event',
        'eventCategory': 'nav_to_cart'
      })
    }
  },
  computed: {
    ...mapGetters([
      'urlLanguagePrefix',
      'cartSort',
      'cartInfoForEcommerce',
      'isCheckoutAsClient',
      'isManager',
      'cartTotalPriceMoreThenTwoThousands',
      'cartModalName'
    ]),
    ...mapState({
      storesInCity: state => state.geoLocation.storesInCity,
      isUserAuth: state => state.user.auth,
      cart: state => state.cart.cart,
      showCartRtbHouseCode: state => state.cart.showCartRtbHouseCode,
      cartProductsIds: state => state.cart.cartSort,
      userData: state => ({
        name: state.user.user_data?.name,
        lastName: state.user.user_data?.['last_name'],
        phone: state.user.user_data?.phone
      }),
      config: state => state.init.config,
      userStore: state => state.geoLocation.userStore
    }),
    computedClassList () {
      let str = 'modal--cart cart'
      if (this.isLoading) {
        str = str + ' cart--loading'
      }
      return str
    },
    hasOnlyPickup () {
      return this.cartSort.products.find(el => el.delivery_status?.only_pickup)
    },
    unavailableItemsForPurchase () {
      return this.cartSort.products.filter(el => Object.values(el.delivery_status).every(value => value === false) && !this.storesInCity.find(store => +store.id === +el.store_id))
    },
    availableProductsInStore () {
      if (this.unavailableItemsForPurchase.length > 0) {
        return this.cartSort.products.filter(el => Object.values(el.delivery_status).some(value => value === true))
      }
      return this.hasOnlyPickup && this.userStore ? this.cartSort.products.filter(el => el.delivery_status?.pickup_status) : this.cartSort.products
    },
    unAvailableProductsInStore () {
      if (this.unavailableItemsForPurchase.length > 0) {
        return this.unavailableItemsForPurchase
      }
      return this.hasOnlyPickup && this.userStore ? this.cartSort.products.filter(el => !el.delivery_status?.pickup_status) : []
    },
    computedCheckoutData () {
      let data = {
        link: this.urlLanguagePrefix + '/checkout/',
        label: this.$t('cart_buy_30_seconds')
      }

      if (this.isCheckoutAsClient && this.isManager) {
        data = {
          link: this.urlLanguagePrefix + '/manager-checkout/',
          label: this.$t('checkout_as_client')
        }
      }

      return data
    },
    analyticsProductsCodes () {
      if (this.cartSort.products.length) {
        let codes = []
        for (let product of this.cartSort.products) {
          codes.push(product.code)
        }
        return codes.join()
      }
      return false
    },
    togetherCheaperDiscount () {
      let discount = null
      this.cartSort.products.forEach(function (product) {
        if (product.discount_amount) discount += product.discount_amount
        else {
          discount += product.itemQuantity * product.price - product.total_position_price
        }
      })
      return Math.floor(discount)
    },
    hasDiscount () {
      return (this.cart.discountInfo?.discountCost ?? 0) > 0
    },
    discountValue () {
      return this.cart.discountInfo?.discountCost ?? 0
    },
    hasFullDiscount () {
      return (this.cart.discountInfo?.fullDiscountCost ?? 0) > 0
    },
    fullDiscountValue () {
      return this.cart.discountInfo?.fullDiscountCost ?? 0
    },
    fullOriginalCost () {
      return this.cart.discountInfo?.fullOriginalCost ?? 0
    },
    isBonusServiceActive () {
      return this.config.service?.is_bonus_service_active
    }
  },
  filters: {
    currencyFormatter
  },
  watch: {
    cartSort () {
      if (this.isUserAuth && !this.isCheckout && this.cartModalName === 'cart-modal') {
        this.SET_LOADING_COMPONENT({ bonusesInModal: true })
        if (this.isBonusServiceActive) {
          this.FETCH_CART_BONUSES_INFO().then(() => this.SET_LOADING_COMPONENT({ bonusesInModal: false }))
        } else {
          this.SET_LOADING_COMPONENT({ bonusesInModal: false })
        }
      }
    }
  }
}
</script>

<style lang="sass">
.cart--loading
  overflow: hidden !important
  .modal-body
    height: 100% !important
    overflow: hidden !important
.cart__products-list--unavailable
  .cart-item-counter
    background-color: #fff
</style>

<style scoped lang="sass">
.unavailable-list
  border: 1px solid #E7E7E7
  border-radius: 3px
  &__remove-all
    color: #3E77AA
    background-color: transparent
    border-color: transparent
    padding: 0
    margin-left: 10px
    text-wrap: nowrap
    font-size: 14px
    line-height: 18px
    text-decoration: underline
    &:hover
      text-decoration: none
  &__title
    padding: 12px 15px
    border-bottom: 1px solid #E7E7E7
    font-size: 14px
    line-height: 21px
    display: flex
    align-items: flex-start
    justify-content: space-between
  .cart__products-list--unavailable
    background-color: #00000008
    padding: 0 14px

::v-deep
  .modal-body
    padding-top: 0
    +mmax(768)
      &:before
        content: ''
        display: block
        height: 1px
        background-color: $nd-border-color
        width: calc(100% + 100px)
        margin: 0 -50px
.cart__products-list
  +list-unstyled

.cart__products-list-item
  padding: 20px 0 15px

  +mmin($tablet--hor)
    padding: 20px 0

  &:not(:first-child)
    border-top: 1px solid $nd-border-color

.cart__wrapper
  padding: 10px 0 30px

  +mmax(768)
    padding: 0 0 15px

.cart__buy-more
  display: flex
  flex-direction: column
  align-items: flex-start
  width: 62.5%

  +mmax($tablet)
    width: 100%

.cart__buy-more-text
  font-weight: 400 //Rubik 300
  font-size: 14px
  line-height: 17px
  color: $placeholder-color
  margin: 0 0 20px

  +mmax($extsmall--hor)
    margin-bottom: 30px

.cart__total
  width: 34%
  margin-left: auto

  +mmax(768)
    width: 100%

.cart__total-text
  display: flex
  flex-flow: row nowrap
  justify-content: space-between

  font-weight: 400 //Rubik 300
  font-size: 16px
  line-height: 24px

  +mmax(768)
    margin-bottom: 20px

  +mmax($extsmall--hor)
    font-size: 18px
    margin-bottom: 30px

  &--together-cheaper
    align-items: flex-end
    font-size: 16px
    line-height: 19px

  &--discount
    align-items: flex-end
    font-size: 14px
    line-height: 19px
    margin-bottom: 10px

.cart__total-title
  align-self: flex-end

.cart__total-number-wrap
  display: flex
  flex-direction: column
  align-items: flex-end

.cart__total-number
  font-weight: 500
  font-size: 20px
  +mmax($extsmall--hor)
    font-size: 24px

  &--together-cheaper
    min-width: 100px
    text-align: right
    color: #FF2F00

  &--discount
    font-size: 18px
    min-width: 100px
    text-align: right

  &--old
    font-size: 16px
    color: $placeholder-color
    text-decoration-line: line-through

.cart__back-to
  background-color: transparent
  font-weight: 400 //Rubik 300
  font-size: 15px
  line-height: 18px
  margin: auto 0 30px 30px
  position: relative

  +mmax($between-phone-tablet)
    display: none

  &--adaptive--show
    +mmax(768)
      display: inline-block
      margin-top: 20px

    +mmax($extsmall--hor)
      margin-top: 0

  svg
    position: absolute
    left: -30px
    vertical-align: middle
    margin-right: 10px

.cart__btn
  display: flex
  align-items: center
  justify-content: center
  width: 100%
  height: 40px
  font-size: 15px
  border: 1px solid $btn-bg
  border-radius: 3px
  background: $btn-bg
  color: $white-text-color
  transition: .4s
  cursor: pointer

  +mmax($extsmall--hor)
    font-size: 18px
    font-weight: 400 //Rubik 300
    height: 50px

  &:hover
    background-color: transparent
    color: $text-color

  &--buy
    margin-top: 20px

  &--buy-manager
    background: #F0F0F0
    color: $text-color
    margin-top: 30px
    border-color: #F0F0F0
  &--disabled
    background-color: #909090
    color: #fff
    pointer-events: none
    border-color: #909090
  &--invert
    border: 1px solid $btn-bg
    background: transparent
    color: $text-color

    &:hover
      background-color: $btn-bg
      color: $white-text-color

.modal__hr
  text-align: center
  margin: 30px 0
  position: relative

  +mmax($extsmall--hor)
    margin: 30px 0

  &:before,
  &:after
    content: ''
    height: 1px
    width: calc(50% - 35px)
    top: 50%
    position: absolute
    background-color: $nd-border-color

  &:before
    left: 0

  &:after
    right: 0

.modal__info
  width: 100%
  display: flex
  justify-content: space-between

  +mmax(768)
    flex-direction: column
    align-items: center

  &--total
    margin-top: 20px
    margin-bottom: 40px
    //
    //+mmin($tablet)
    //  align-items: flex-end

  &--together-cheaper
    +mmax($between-phone-tablet)
      padding-bottom: 100px

  &--page--checkout
    +mmax(768)
      flex-direction: column-reverse

.one-click
  +mmax($between-phone-tablet)
    padding-bottom: 100px

.one-click__text
  width: 62.5%

  +mmax(768)
    width: 100%
    padding-right: 20px
    margin-bottom: 20px

  +mmax($between-phone-tablet)
    padding-right: 0

.one-click-text__title
  font-size: 16px
  line-height: 19px
  color: $text-color

.one-click-text__paragraph
  font-weight: 400 //Rubik 300
  font-size: 14px
  line-height: 17px
  color: #909090
  margin: 20px 0 0

.one-click__form
  width: 43%
  margin-left: auto

  @media only screen and (max-width: 768px)
    width: 100%

  +mmax(768)
    margin: 0 auto

  +mmax($extsmall--hor)
    max-width: none

  ::v-deep .quick-order-form__row
    flex-direction: column
    .quick-order-form__col
      width: 100%
    .quick-order-form__footer
      margin-top: 15px
    .control-box
      min-height: unset

.control-box--phone
  margin-bottom: 20px

.one-click-form__control
  font-size: 16px
  font-weight: 400 //Rubik 300
  color: $text-color
  margin: 0
  width: 100%
  height: 40px
  padding: 0 11px
  border: 1px solid $nd-border-color
  border-radius: 3px

  &::placeholder
    color: $placeholder-color

  &:focus
    border: 1px solid $nd-focus-border-color
.empty-cart
  +mmax($tablet)
    margin-top: 50px
.empty-cart__title
  margin-top: 40px
  font-size: 20px
  font-weight: 500

  +mmin($tablet)
    margin-top: 30px
    font-size: 24px

.empty-cart__text
  font-weight: 400 //Rubik 300
  font-size: 16px
  line-height: 19px
  text-align: center
  color: $placeholder-color
  margin-top: 10px

.empty-cart__img
  width: 120px
  height: 100px
  background-image: url(/img/svgo/empty-cart-1.svg)
  background-repeat: no-repeat
  background-size: contain
  margin: 0 auto

.sale-notification
  color: $nd-green-text-color
  font-size: 14px
  display: block
  margin-bottom: 20px

.cart__info-message-wrap
  width: 100%
  margin: 0 0 15px

  &:last-child
    margin: 0 0 40px

    +mmin($tablet)
      margin: 0
</style>

<style lang="scss" scoped>
.cart-modal-upsell-products {
    ::v-deep {
      .product-card {
        &__characteristics-link {
          display: none;
        }
      }
    }
}
</style>
